import { i18nMark } from 'lingui-react';

const NATIONAL = {
  type: 'NATIONAL',
  label: i18nMark('National'),
};

const STORE = {
  type: 'STORE',
  types: ['CUSTOM_STORE', 'STORE'],
  label: i18nMark('Store'),
};

const CUSTOM_STORE = {
  type: 'CUSTOM_STORE',
};

const OTHER = {
  type: 'OTHER',
  label: i18nMark('Other'),
};

// These customer types are intended to map customer type ENUM values to labels
export const CUSTOMER_TYPES = { NATIONAL, STORE, CUSTOM_STORE, OTHER };
export const CUSTOMER_TYPE_OPTIONS = [NATIONAL, STORE, OTHER];



// WEBPACK FOOTER //
// ./src/compositions/WithCaseCustomerType/constants.js